import { debounce } from './ThrottleDebounce';



// Конец скролла
const debounceScroll = debounce(() => {
    App.W.trigger('scrolled');
}, 100);

App.W.on('scroll', () => {
    debounceScroll();
});



// Конец ресайза
const debounceResize = debounce(() => {
    App.W.trigger('resized');
}, 200);

App.W.on('resize', () => {
    debounceResize();
});



// WEBPACK FOOTER //
// ./_src/js/modules/WindowEvents.js